import { gql, useMutation } from "@apollo/client";

const SAVE_CLIENT_MEDICAL_FORM_DETAILS=gql`
mutation SaveClientMedicalFormDetails($title: clientTitleTypes, $clientId: Int, $firstName: String, $lastName: String, $dob: String, $latitude: String, $longitude: String, $address: String, $houseNumber: String, $streetName: String, $city: String, $postCode: String, $email: String, $mobile: String, $phoneNoCountry: String, $countryCode: String, $medicalHomeTelephone: String, $medicalOfficeTelephone: String, $clientSignature: String, $practitionerSignature: String, $token: String, $isMedicalHistory: Int, $qas: [QAInputType], $clientIds: [Int]) {
  saveClientMedicalFormDetails(title: $title, clientId: $clientId, firstName: $firstName, lastName: $lastName, dob: $dob, latitude: $latitude, longitude: $longitude, address: $address, houseNumber: $houseNumber, streetName: $streetName, city: $city, postCode: $postCode, email: $email, mobile: $mobile, phoneNoCountry: $phoneNoCountry, countryCode: $countryCode, medicalHomeTelephone: $medicalHomeTelephone, medicalOfficeTelephone: $medicalOfficeTelephone, clientSignature: $clientSignature, practitionerSignature: $practitionerSignature, token: $token, isMedicalHistory: $isMedicalHistory, qas: $qas, clientIds: $clientIds) {
    success
    message
    data {
      id
      name
      email
      dob
      mobile
      phone_country
      country_code
      latitude
      longitude
      address
      house_no
      street_name
      city
      postcode
      prc_name
      prc_email
      prc_address
      prc_mobile
      prc_phone_country
      prc_country_code
      medical_date
      title
      medical_home_phone
      medical_qas {
        question
        id
        hasSubQuestions
        subQuestions {
          question
          id
          comment
          answer
        }
        comment
        answer
      }
      practitioner_signature
      medical_signature
      remainingClientIds
    }
    
  }
}
`;

export const SaveClientMedicalFormDetailsAction=()=>{
    const [
        saveClientMedicalFormDetailResponseFunction,
        saveClientMedicalFormDetailsresponseData,]=useMutation(SAVE_CLIENT_MEDICAL_FORM_DETAILS);

    const saveClientMedicalFormDetailQueryData=saveClientMedicalFormDetailsresponseData;

    const initSaveClientMedicalFormDetailsData=(data, successCallback, errorCallback)=>{
            saveClientMedicalFormDetailResponseFunction({
                variables:data
            }).then((responseData)=>{
               if(responseData.data.saveClientMedicalFormDetails.success){
                successCallback(responseData.data.saveClientMedicalFormDetails)
               }else{
                errorCallback(responseData)
               }
            }).catch((err)=>{
                errorCallback(err)
            })
    }
    return {saveClientMedicalFormDetailQueryData,initSaveClientMedicalFormDetailsData}
}